(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-mix-match"] && !Shopify.designMode) return;
  try {
    
(() => {
  class BundleMoney extends HTMLElement {
    static convert(usd, currency) {
      const active = window.Shopify?.currency;
      const rate = currency === 'USD' ? 1 : active?.active === currency ? Number(active.rate) : NaN;
      if (!Number.isFinite(rate) || rate <= 0) return null;
      return Math.round(Number(usd) * rate * 100);
    }
    connectedCallback() {
      const currency = this.dataset.currency;
      const cents = BundleMoney.convert(this.dataset.usd, currency);
      if (cents === null) return;
      this.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: 0 }).format(cents / 100);
    }
  }
  if (!customElements.get('bc-bundle-money')) customElements.define('bc-bundle-money', BundleMoney);
})();

(() => {
  class MixMatch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('[data-mix-dialog]');
      this.zoom = this.querySelector('[data-mix-zoom]');
      this.strings = JSON.parse(this.querySelector('[data-mix-strings]').textContent);
      this.selected = new Map();
      this.cards = [...this.querySelectorAll('[data-mix-card]')];
      this.visibleCards = [...this.cards];
      this.feedGeneration = 0;
      this.step = 'designs';
      this.cards.forEach(card => this.initCard(card));
      this.feedNext = this.dataset.feedUrl || null;
      this.addEventListener('change', event => {
        if (event.target.hasAttribute('data-mix-catalogue')) {
          if (!this.busy) this.switchCatalogue(event.target.selectedOptions[0]);
          return;
        }
        const card = event.target.closest('[data-mix-card]');
        if (!card || this.busy) return;
        if (event.target.hasAttribute('data-mix-size')) this.lastSize = event.target.value;
        const wasSelected = this.selected.has(card.dataset.productId);
        this.updateCard(card);
        if (wasSelected && !this.selected.has(card.dataset.productId) && this.step === 'options') this.renderStep();
        this.summary();
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || this.busy) return;
        if (button.hasAttribute('data-mix-close')) this.dialog.close();
        if (button.hasAttribute('data-mix-zoom-close')) this.zoom.close();
        const card = button.closest('[data-mix-card]');
        if (button.dataset.mixCartPreview) {
          const item = this.cartItems().find(item => item.key === button.dataset.mixCartPreview);
          if (item?.image) this.previewImage(item.image, item.title);
        }
        if (button.hasAttribute('data-mix-swatch')) this.chooseColour(card, button);
        if (button.hasAttribute('data-mix-preview')) this.preview(card);
        if (button.hasAttribute('data-mix-pick')) {
          const id = card.dataset.productId;
          if (this.selected.has(id)) this.selected.delete(id);
          else this.selected.set(id, card.variant?.available ? card.variant : null);
          this.updateCard(card);
          if (this.step === 'options') {
            this.renderStep();
            this.querySelector('[data-mix-heading]').focus({ preventScroll: true });
          }
          this.summary();
        }
        if (button.dataset.mixRemove) {
          this.selected.delete(button.dataset.mixRemove);
          this.updateCard(this.cards.find(card => card.dataset.productId === button.dataset.mixRemove));
          this.summary();
        }
        if (button.hasAttribute('data-mix-add')) this.addAll();
        if (button.hasAttribute('data-mix-next')) this.setStep('options');
        if (button.hasAttribute('data-mix-back')) this.setStep('designs');
        if (button.hasAttribute('data-mix-more')) this.loadMore(true);
      });
      this.dialog.addEventListener('cancel', event => { if (this.busy) event.preventDefault(); });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.opener?.focus({ preventScroll: true });
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog && !this.busy) this.dialog.close(); });
      this.zoom.addEventListener('click', event => { if (event.target === this.zoom) this.zoom.close(); });
      this.summary();
    }
    root() { return window.Shopify?.routes?.root || '/'; }
    text(key, values = {}) { return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('[' + name + ']', value), this.strings[key] || ''); }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'symbol' }).format(cents / 100); }
    discountRate(count) {
      const usd = count >= 3 ? 3 : count === 2 ? 2 : 0;
      const helper = customElements.get('bc-bundle-money');
      if (helper?.convert) return helper.convert(usd, this.dataset.currency);
      return this.dataset.currency === 'USD' ? usd * 100 : null;
    }
    cartItems() { return this.state?.eligible_items || []; }
    inCart(variant) { return variant && this.cartItems().some(item => String(item.variant_id) === String(variant.id)); }
    restoreCartVariant(card) {
      if (this.selected.has(card.dataset.productId)) return;
      const item = this.cartItems().find(item => String(item.product_id) === card.dataset.productId);
      const variant = item && card.product.variants.find(variant => String(variant.id) === String(item.variant_id));
      if (variant) card.selects.forEach((select, index) => { select.value = variant.options[index]; });
    }
    syncCart(state) {
      this.state = state;
      for (const [id, variant] of this.selected) if (this.inCart(variant)) this.selected.delete(id);
      this.cards.forEach(card => { this.restoreCartVariant(card); this.updateCard(card); });
      this.renderCartItems();
      this.renderStep();
    }
    renderCartItems() {
      const container = this.querySelector('[data-mix-existing]');
      if (!container) return;
      container.replaceChildren();
      container.hidden = !this.cartItems().length;
      this.cartItems().forEach(item => {
        const row = document.createElement('article');
        row.className = 'bc-mix-existing-row';
        const preview = document.createElement('button');
        preview.type = 'button';
        preview.className = 'bc-mix-image';
        preview.dataset.mixCartPreview = item.key;
        preview.setAttribute('aria-label', this.text('preview', { title: item.title }));
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        preview.append(image);
        const body = document.createElement('div');
        const title = document.createElement('h3');
        title.textContent = item.title.replace(/ T-Shirt$/, '');
        const options = document.createElement('p');
        options.textContent = this.text('cart_options', { options: item.options.join(' / '), quantity: item.quantity });
        const price = document.createElement('p');
        price.textContent = this.money(item.price * item.quantity);
        const status = document.createElement('strong');
        status.textContent = this.text('in_cart');
        body.append(title, options, price, status);
        row.append(preview, body);
        container.append(row);
      });
      if (this.cartItems().length) {
        const edit = document.createElement('a');
        edit.href = this.root() + 'cart';
        edit.textContent = this.text('edit_cart');
        container.append(edit);
      }
    }
    setStep(step) {
      if (this.busy || this.feedBusy || (step === 'options' && !this.selected.size && !this.cartItems().length)) return;
      this.step = step;
      this.renderStep();
      this.querySelector('.bc-mix-scroll').scrollTop = 0;
      this.querySelector('[data-mix-heading]').focus({ preventScroll: true });
      this.summary();
    }
    renderStep() {
      if (!this.selected.size && !this.cartItems().length) this.step = 'designs';
      const review = this.step === 'options';
      this.dataset.step = this.step;
      this.querySelector('[data-mix-discover]').hidden = review;
      this.querySelector('[data-mix-review-panel]').hidden = !review;
      this.querySelector('[data-mix-next]').hidden = review;
      this.querySelector('[data-mix-add]').hidden = !review;
      this.querySelector('[data-mix-selected]').hidden = review;
      this.querySelector('[data-mix-step]').textContent = this.text(review ? 'step_options' : 'step_designs');
      this.querySelector('[data-mix-heading]').textContent = this.text(review ? 'review_heading' : 'heading');
      this.querySelector('[data-mix-review-grid]').replaceChildren(...(review ? this.cards.filter(card => this.selected.has(card.dataset.productId)) : []));
      if (!review) this.querySelector('.bc-mix-grid').replaceChildren(...this.visibleCards);
      this.cards.forEach(card => this.updateCard(card));
    }
    initCard(card) {
      card.product = JSON.parse(card.querySelector('[data-mix-product]').textContent);
      card.selects = [...card.querySelectorAll('[data-mix-option]')];
      const first = card.product.variants.find(variant => variant.available);
      card.selects.forEach((select, index) => {
        if (!select.hasAttribute('data-mix-size')) select.value = first?.options[index] || '';
        else if (this.lastSize && [...select.options].some(option => option.value === this.lastSize)) select.value = this.lastSize;
      });
      this.restoreCartVariant(card);
      this.updateCard(card);
    }
    chooseColour(card, button) {
      if (!card || this.busy || button.disabled) return;
      const index = Number(button.dataset.mixOptionIndex);
      const colour = button.dataset.mixColour;
      const select = card.selects[index];
      if (!select || !card.product.variants.some(variant => variant.available && variant.options[index] === colour)) return;
      select.value = colour;
      const size = card.querySelector('[data-mix-size]');
      if (size?.value && !card.product.variants.some(variant => variant.available && variant.options.every((value, position) => !card.selects[position].value || card.selects[position].value === value))) size.value = '';
      this.updateCard(card);
      this.summary();
    }
    feedButton() {
      const button = this.querySelector('[data-mix-more]');
      button.disabled = Boolean(this.feedBusy || this.busy);
      button.hidden = !this.feedNext;
      button.textContent = this.text(this.feedBusy ? 'loading_designs' : this.feedFailed ? 'retry_designs' : 'browse_more');
    }
    matchesCatalogue(card) {
      const tag = (this.dataset.catalogueTag || '').toLowerCase();
      return !tag || JSON.parse(card.dataset.tags || '[]').some(value => value.toLowerCase() === tag);
    }
    async switchCatalogue(option) {
      if (!option || this.busy || option.value === this.dataset.catalogueTag) return;
      this.feedGeneration++;
      this.feedController?.abort();
      this.dataset.catalogueTag = option.value;
      this.dataset.feedUrl = option.dataset.url;
      this.feedNext = option.dataset.url;
      this.feedBusy = false;
      this.feedLoaded = false;
      this.feedFailed = false;
      const label = option.textContent.trim();
      this.querySelector('[data-mix-catalogue-title]').textContent = this.text('catalogue_heading', { catalogue: label });
      this.visibleCards = this.cards.filter(card => card.dataset.productId === this.dataset.currentProduct && this.matchesCatalogue(card));
      this.querySelector('.bc-mix-grid').replaceChildren(...this.visibleCards);
      await this.loadMore();
    }
    async loadMore(focus = false) {
      if (this.feedBusy || this.busy || !this.feedNext) return;
      const generation = this.feedGeneration;
      const controller = new AbortController();
      this.feedController = controller;
      this.feedBusy = true;
      this.feedFailed = false;
      this.feedButton();
      this.summary();
      const status = this.querySelector('[data-mix-feed-status]');
      const grid = this.querySelector('.bc-mix-grid');
      status.textContent = this.text('loading_designs');
      grid.setAttribute('aria-busy', 'true');
      let firstAdded;
      try {
        for (let page = 0; page < 5 && this.feedNext; page++) {
          const url = new URL(this.feedNext, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid feed');
          url.searchParams.set('section_id', 'bc-mix-feed');
          url.searchParams.set('sort_by', 'best-selling');
          const response = await fetch(url.href, { cache: 'no-store', signal: AbortSignal.any([controller.signal, AbortSignal.timeout(12000)]) });
          if (generation !== this.feedGeneration) return;
          if (!response.ok) throw new Error('Feed unavailable');
          const feed = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-mix-feed]');
          if (generation !== this.feedGeneration) return;
          if (!feed) throw new Error('Feed unavailable');
          const catalogueTag = (this.dataset.catalogueTag || '').toLowerCase();
          const tags = JSON.parse(feed.dataset.mixTags || '[]');
          if (catalogueTag && !tags.some(tag => tag.toLowerCase() === catalogueTag)) throw new Error('Catalogue filter unavailable');
          const catalogueSelect = this.querySelector('[data-mix-catalogue]');
          const catalogueOptions = feed.querySelector('[data-mix-catalogues]')?.content.querySelectorAll('option') || [];
          catalogueOptions.forEach(option => {
            if (![...catalogueSelect.options].some(existing => existing.value === option.value)) catalogueSelect.append(option.cloneNode(true));
          });
          const seen = new Set(this.visibleCards.map(card => card.dataset.productId));
          const additions = [...feed.querySelectorAll('[data-mix-card]')].filter(card => {
            if (!this.matchesCatalogue(card)) return false;
            if (seen.has(card.dataset.productId)) return false;
            seen.add(card.dataset.productId);
            return true;
          }).map(card => {
            const cached = this.cards.find(existing => existing.dataset.productId === card.dataset.productId);
            if (cached) return cached;
            this.initCard(card);
            this.cards.push(card);
            return card;
          });
          this.visibleCards.push(...additions);
          grid.append(...additions);
          firstAdded ||= additions[0];
          this.feedNext = feed.dataset.next || null;
          this.feedLoaded = true;
          if (additions.length) break;
        }
        status.textContent = this.text(this.feedNext ? 'designs_loaded' : 'all_designs_loaded', { count: this.visibleCards.length });
        if (focus && firstAdded && this.dialog.open) firstAdded.querySelector('[data-mix-preview]')?.focus();
      } catch {
        if (generation !== this.feedGeneration) return;
        this.feedFailed = true;
        status.textContent = this.text('designs_error');
      } finally {
        if (generation === this.feedGeneration) {
          this.feedBusy = false;
          grid.setAttribute('aria-busy', 'false');
          this.feedButton();
          this.summary();
        }
      }
    }
    error(message) {
      const element = this.querySelector('[data-mix-error]');
      element.textContent = message || '';
      element.hidden = !message;
    }
    async cartState() {
      const response = await fetch(this.root() + '?section_id=bc-mix-cart-state', { cache: 'no-store', signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error(this.text('cart_error'));
      return this.parseState(await response.text());
    }
    parseState(html) {
      const element = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bc-cart-state]');
      if (!element) throw new Error(this.text('cart_error'));
      const data = JSON.parse(element.textContent);
      if (!Array.isArray(data.eligible_items)) throw new Error(this.text('cart_error'));
      data.has_code ||= data.cart.discount_codes?.some(code => code.applicable !== false);
      return data;
    }
    async open(opener) {
      if (this.dialog.open) return;
      const generation = this.openGeneration = (this.openGeneration || 0) + 1;
      this.opener = opener;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.step = 'designs';
      this.renderStep();
      this.dialog.showModal();
      if (!this.feedLoaded || this.feedFailed) this.loadMore();
      this.loading = true;
      this.querySelector('[data-mix-cart-note]').textContent = this.text('loading');
      this.error('');
      this.summary();
      try {
        const state = await this.cartState();
        if (generation !== this.openGeneration) return;
        this.syncCart(state);
        this.uncertain = false;
        let note = this.state.eligible_count ? this.text('cart_count', { count: this.state.eligible_count }) : '';
        if (!this.hasOpened) {
          const current = this.cards.find(card => card.dataset.productId === this.dataset.currentProduct);
          const component = [...document.querySelectorAll('product-form-component')].find(node => node.dataset.productId === this.dataset.currentProduct);
          const id = component?.querySelector('input[name="id"]')?.value;
          const picker = component?.sizePicker;
          const variant = current?.product.variants.find(v => String(v.id) === id);
          if (variant?.available && picker?.isSizeSelectionReady?.(id) && !this.cartItems().some(item => String(item.product_id) === this.dataset.currentProduct)) {
            current.selects.forEach((select, index) => { select.value = variant.options[index]; });
            this.lastSize = current.querySelector('[data-mix-size]')?.value;
            const exists = this.state.cart.items.some(item => String(item.variant_id) === id);
            if (!exists) this.selected.set(current.dataset.productId, variant);
            note += ' ' + this.text(exists ? 'already' : 'carried');
            this.updateCard(current);
          }
          if (this.lastSize) this.cards.forEach(card => {
            const select = card.querySelector('[data-mix-size]');
            if (select && !select.value && [...select.options].some(option => option.value === this.lastSize)) {
              select.value = this.lastSize;
              this.updateCard(card);
            }
          });
          this.hasOpened = true;
        }
        this.querySelector('[data-mix-cart-note]').textContent = note.trim();
      } catch (error) {
        if (generation !== this.openGeneration) return;
        this.state = null;
        this.renderCartItems();
        this.cards.forEach(card => this.updateCard(card));
        this.error(this.text('cart_error'));
      } finally {
        if (generation !== this.openGeneration) return;
        this.loading = false;
        this.summary();
      }
    }
    updateCard(card) {
      const values = card.selects.map(select => select.value);
      card.selects.forEach((select, index) => {
        if (!select.hasAttribute('data-mix-size')) return;
        [...select.options].forEach(option => {
          if (!option.value) return;
          option.disabled = !card.product.variants.some(variant => variant.available && variant.options[index] === option.value && variant.options.every((value, j) => j === index || !values[j] || value === values[j]));
        });
      });
      card.variant = card.product.variants.find(variant => variant.options.every((value, index) => value === values[index]));
      const firstMatching = card.variant || card.product.variants.find(variant => variant.available && variant.options.every((value, index) => !values[index] || value === values[index]));
      card.querySelector('[data-mix-price]').textContent = this.money(firstMatching?.price || card.product.variants[0].price);
      const image = card.querySelector('img');
      const imageSource = firstMatching?.featured_image?.src || card.product.image;
      if (image && imageSource && image.dataset.source !== imageSource) {
        image.dataset.source = imageSource;
        const thumbnail = new URL(imageSource, location.origin);
        thumbnail.searchParams.set('width', '640');
        image.src = thumbnail.href;
        image.removeAttribute('srcset');
      }
      const inCart = this.inCart(card.variant);
      if (inCart) this.selected.delete(card.dataset.productId);
      const selected = this.selected.has(card.dataset.productId);
      if (selected) this.selected.set(card.dataset.productId, card.variant?.available ? card.variant : null);
      card.dataset.selected = String(selected || inCart);
      card.querySelectorAll('[data-mix-swatch]').forEach(swatch => {
        const index = Number(swatch.dataset.mixOptionIndex);
        swatch.setAttribute('aria-pressed', String(values[index] === swatch.dataset.mixColour));
        swatch.disabled = Boolean(this.busy || !card.product.variants.some(variant => variant.available && variant.options[index] === swatch.dataset.mixColour));
      });
      card.querySelectorAll('[data-mix-colour-name]').forEach(label => { label.textContent = values[Number(label.dataset.mixColourName)] || ''; });
      const complete = values.every(Boolean);
      card.querySelector('[data-mix-availability]').textContent = complete && !card.variant?.available ? this.text('unavailable') : '';
      const button = card.querySelector('[data-mix-pick]');
      button.disabled = Boolean(this.busy || inCart);
      button.setAttribute('aria-pressed', String(selected || inCart));
      button.textContent = inCart ? this.text('in_cart') : selected ? this.text(this.step === 'options' ? 'remove_design' : 'selected') : this.text('pick');
    }
    summary() {
      if (!this.selected) return;
      const count = this.selected.size;
      const variants = [...this.selected.values()];
      const complete = variants.every(Boolean);
      const prices = [...this.selected.entries()].map(([id, variant]) => variant?.price || Math.min(...this.cards.find(card => card.dataset.productId === id).product.variants.filter(v => v.available).map(v => v.price)));
      const cartPrices = this.cartItems().flatMap(item => Array(item.quantity).fill(item.price));
      const allPrices = [...cartPrices, ...prices];
      const subtotal = allPrices.reduce((sum, price) => sum + price, 0);
      const totalCount = (this.state?.eligible_count || 0) + count;
      const rate = this.discountRate(totalCount);
      const canEstimate = rate !== null && this.state && !this.state.has_code;
      const savings = canEstimate ? allPrices.reduce((sum, price) => sum + Math.min(rate, price), 0) : 0;
      const estimated = canEstimate ? subtotal - savings : prices.reduce((sum, price) => sum + price, 0) + this.cartItems().reduce((sum, item) => sum + item.final_line_price, 0);
      const hasCart = this.cartItems().length > 0;
      this.querySelector('[data-mix-count]').textContent = this.text(hasCart ? (totalCount === 1 ? 'bundle_one' : 'bundle_count') : count === 1 ? 'one_count' : 'count', { count: totalCount });
      this.querySelector('[data-mix-total]').textContent = totalCount ? this.text(complete ? 'estimate' : 'from_total', { amount: this.money(estimated) }) : this.text('empty');
      let progress = savings ? this.text('saving', { amount: this.money(savings) }) : '';
      if (this.step === 'options' && !complete) progress = this.text('sizes_needed');
      if (this.state?.has_code && this.step === 'options') progress = this.text('code_note');
      this.querySelector('[data-mix-progress]').textContent = progress;
      const chips = this.querySelector('[data-mix-selected]');
      const cartChips = this.cartItems().map(item => {
        const chip = document.createElement('span');
        chip.className = 'bc-mix-chip bc-mix-chip-cart';
        const title = document.createElement('span');
        title.textContent = item.title.replace(/ T-Shirt$/, '') + (item.quantity > 1 ? ' ×' + item.quantity : '');
        const detail = document.createElement('small');
        detail.textContent = this.text('cart_chip', { options: item.options.join(' / ') });
        chip.append(title, detail);
        return chip;
      });
      chips.replaceChildren(...cartChips, ...[...this.selected.entries()].map(([id, variant]) => {
        const card = this.cards.find(card => card.dataset.productId === id);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bc-mix-chip';
        button.dataset.mixRemove = id;
        button.setAttribute('aria-label', this.text('remove') + ' ' + card.dataset.title);
        const span = document.createElement('span');
        span.textContent = card.dataset.title.replace(/ T-Shirt$/, '');
        button.disabled = Boolean(this.busy);
        button.append(span, ' ×');
        return button;
      }));
      const add = this.querySelector('[data-mix-add]');
      add.disabled = this.busy || this.loading || this.feedBusy || this.uncertain || !this.state || !totalCount || !complete;
      add.textContent = this.busy ? this.text('adding') : !count && hasCart ? this.text('view_cart') : this.text(hasCart ? 'add_new' : 'add_count', { count });
      const next = this.querySelector('[data-mix-next]');
      next.disabled = Boolean(this.busy || this.loading || this.feedBusy || !totalCount || !this.state || this.uncertain);
      next.textContent = this.text(!count && hasCart ? 'review_bundle' : 'next_step');
    }
    preview(card) {
      const image = card.querySelector('img')?.cloneNode();
      if (!image) return;
      const source = card.variant?.featured_image?.src || image.dataset.source || card.product.image;
      const url = new URL(source, location.origin);
      url.searchParams.set('width', '1400');
      image.src = url.href;
      image.removeAttribute('srcset');
      image.removeAttribute('loading');
      this.querySelector('[data-mix-zoom-image]').replaceChildren(image);
      this.querySelector('[data-mix-zoom-title]').textContent = card.dataset.title;
      this.zoom.showModal();
    }
    previewImage(source, title) {
      const image = document.createElement('img');
      const url = new URL(source, location.origin);
      url.searchParams.set('width', '1400');
      image.src = url.href;
      image.alt = title;
      this.querySelector('[data-mix-zoom-image]').replaceChildren(image);
      this.querySelector('[data-mix-zoom-title]').textContent = title;
      this.zoom.showModal();
    }
    lock(busy) {
      this.busy = busy;
      this.querySelectorAll('button, select').forEach(control => {
        if (busy) { control.dataset.wasDisabled = String(control.disabled); control.disabled = true; }
        else control.disabled = control.dataset.wasDisabled === 'true';
      });
      this.summary();
      this.feedButton();
    }
    notifyCart(state, sections) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: state?.cart || {}, sourceId: 'bc-mix-match', data: { source: 'bc-mix-match', itemCount: state?.cart.item_count || 0, sections } } }));
    }
    async addAll() {
      if (this.busy || this.loading || this.feedBusy || this.uncertain || [...this.selected.values()].some(variant => !variant?.available)) return;
      if (!this.selected.size) {
        if (this.cartItems().length) location.assign(this.root() + 'cart');
        return;
      }
      this.error('');
      this.querySelector('[data-mix-review]').hidden = true;
      this.lock(true);
      let before;
      let attempted = false;
      let added = false;
      try {
        before = await this.cartState();
        const alreadyPresent = [...this.selected.values()].some(variant => before.cart.items.some(item => String(item.variant_id) === String(variant.id)));
        if (alreadyPresent) {
          this.syncCart(before);
          this.error(this.text('cart_changed'));
          return;
        }
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0, 4);
        sections.push('bc-mix-cart-state');
        const items = [...this.selected.values()].map(variant => ({ id: variant.id, quantity: 1 }));
        attempted = true;
        const response = await fetch(this.root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: location.pathname }), signal: AbortSignal.timeout(20000) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.text('error'));
        added = true;
        let state;
        try { state = this.parseState(result.sections?.['bc-mix-cart-state'] || ''); } catch { state = await this.cartState(); }
        this.state = state;
        this.selected.clear();
        this.cards.forEach(card => this.updateCard(card));
        this.dialog.close();
        this.notifyCart(state, result.sections);
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer?.showDialog) drawer.showDialog();
        else location.assign(this.root() + 'cart');
      } catch (error) {
        if (attempted) {
          try {
            const after = await this.cartState();
            const quantity = (state, id) => state.cart.items.filter(item => String(item.variant_id) === String(id)).reduce((sum, item) => sum + item.quantity, 0);
            let removed = 0;
            for (const [id, variant] of this.selected) {
              if (added || quantity(after, variant.id) > quantity(before, variant.id)) { this.selected.delete(id); removed++; }
            }
            this.syncCart(after);
            this.error(removed ? this.text('partial') : error.message || this.text('error'));
          } catch {
            this.uncertain = true;
            this.error(this.text('uncertain'));
          }
          this.querySelector('[data-mix-review]').hidden = false;
        } else this.error(this.text('cart_error'));
      } finally {
        this.lock(false);
        this.renderStep();
        this.summary();
      }
    }
  }
  if (!customElements.get('bc-mix-match')) customElements.define('bc-mix-match', MixMatch);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-bc-open-selector]');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const selector = document.querySelector('bc-mix-match');
    if (!selector) return;
    event.preventDefault();
    selector.open(link);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
